// Typed adaptation of selected Coursework V2 app/scale/model.mjs.
// Validation assists editing; the native server owns terms and grading.
import type { GradingScale } from "./types";

export function scaleMaximum(scale: GradingScale | null | undefined): number | null {
  const scores = (scale?.rows ?? [])
    .filter(row => row.score !== null && row.score !== undefined && String(row.score).trim() !== "")
    .map(row => Number(row.score)).filter(Number.isFinite);
  return scores.length ? Math.max(...scores) : null;
}

export function validateScale(terms: { scale?: GradingScale | null; points: number | null }) {
  const rows = terms.scale?.rows;
  if (!Array.isArray(rows) || !rows.length) throw Error("Add a grading level before publishing.");
  const ids = new Set<string>(), names = new Set<string>();
  for (const [index, row] of rows.entries()) {
    const label = row.level?.trim() || `Row ${index + 1}`;
    if (!row.id || ids.has(row.id)) throw Error("Each grading row needs its own identity.");
    ids.add(row.id);
    if (!row.level?.trim()) throw Error(`Row ${index + 1}: name this grading level.`);
    const key = row.level.trim().toLocaleLowerCase();
    if (names.has(key)) throw Error(`${label}: use a distinct level name.`);
    names.add(key);
    if (!row.meaning?.trim()) throw Error(`${label}: describe what this level means.`);
    if (row.score === null || row.score === undefined || String(row.score).trim() === "" || !Number.isFinite(Number(row.score)) || Number(row.score) < 0)
      throw Error(`${label}: enter a nonnegative score explicitly, including zero if intended.`);
  }
  const maximum = scaleMaximum(terms.scale);
  if (maximum === null || maximum <= 0) throw Error("The highest scale score must be greater than zero.");
  if (terms.points !== maximum) throw Error("The assignment maximum must match its highest scale score.");
  return rows;
}

export function resolveScale(terms: { scale?: GradingScale | null; points: number | null }, rowId: string | null | undefined) {
  const row = validateScale(terms).find(row => row.id === rowId);
  if (!row) throw Error("Choose one level from the scale for this exact attempt.");
  return { score: Number(row.score), scaleRow: row.id, criteria: {} };
}
